import { Service } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface ServicesState extends EntityState<Service> {}

export const servicesAdapter: EntityAdapter<Service> = createEntityAdapter<Service>({
  selectId: (service: Service) => service.id
});

export const initialState: ServicesState = servicesAdapter.getInitialState({});
export const servicesFeatureSelector = createFeatureSelector<any>('labourOperations');
export const servicesSelector = createSelector(
  servicesFeatureSelector,
  (state: any) => state.services
);
export const { selectIds, selectEntities, selectAll, selectTotal } = servicesAdapter.getSelectors(servicesSelector);
